<script setup lang="ts">
import { useTemplateRef } from "vue";

const modelValue = defineModel<string>({ required: true });

const inputRef = useTemplateRef("input");

defineExpose({
  focus: () => void inputRef.value?.focus(),
  blur: () => void inputRef.value?.blur(),
});
</script>

<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <input ref="input" v-model="modelValue" class="base-input-text" type="text" />
</template>

<style lang="scss">
@use "@/styles/variables/colors";
@use "@/styles/variables";

.base-input-text {
  cursor: text;

  &::placeholder {
    color: colors.$text-placeholder;
  }

  // Override for Chrome when an autofillable input is autofilled
  &:-webkit-autofill {
    box-shadow: 0 0 0 30px colors.$background-ui inset; // check-style-disable
  }
}
</style>
